import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'opac-tab-panel',
  templateUrl: './tab-panel.component.html',
  styleUrls: ['./tab-panel.component.scss']
})
export class TabPanelComponent {
  active: boolean = false;
  tabId: string;

  @Input() name!: string;
  @Input() tabindex: number = 0;

  @ViewChild('panelEl', { static: true }) panelElement: ElementRef<HTMLDivElement>;

  focus() {
    this.panelElement.nativeElement.focus();
  }
}
